module.exports = __webpack_public_path__ + "img/37.4c6805d6.jpg";